interface Props {
    label: string,
    content: string|JSX.Element
}

const BoxInfo = ({ label, content } : Props) => {

    return (
        <div className="box-info p-4 rounded-lg">
            <div className="label">{ label }</div>
            <div>{ content }</div>
        </div>
    )
}

export default BoxInfo;
